import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Layouts from "../../layouts/layouts";

export default function Create_Type() {
  const title = "Add Type";

  const [formData, setFormData] = useState({
    vehiclename: "",
    company: "",
    vehicle_type: "",
    vehicleCategory: "",
    firstServiceKm: "",
    firstServiceDays: "",
    secondServiceKm: "",
    secondServiceDays: "",
    thirdServiceKm: "",
    thirdServiceDays: "",
    fixedServiceKm: "",
    fixedServiceDays: "",
    feet: "",
    battery: "",
    amount: "",
    oemDetails: [
      {
        name: "",
        contact: "",
        email: "",
      },
    ],
  });

  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const brad = [{ name: "Home" }, { name: title }];

  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // Handle OEM field changes
  const onOEMChangeHandler = (index, event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => {
      const updatedOEMDetails = [...prevFormData.oemDetails];

      updatedOEMDetails[index] = {
        ...updatedOEMDetails[index],
        [name]: value,
      };

      return {
        ...prevFormData,
        oemDetails: updatedOEMDetails,
      };
    });
  };

  // Add another OEM
  const addOEM = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      oemDetails: [
        ...prevFormData.oemDetails,
        {
          name: "",
          contact: "",
          email: "",
        },
      ],
    }));
  };

  // Remove OEM
  const removeOEM = (index) => {
    setFormData((prevFormData) => {
      const updatedOEMDetails = prevFormData.oemDetails.filter(
        (_, i) => i !== index,
      );

      return {
        ...prevFormData,
        oemDetails: updatedOEMDetails,
      };
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.vehiclename.trim()) {
      newErrors.vehiclename = "Vehicle Type is required";
    }

    if (!formData.company.trim()) {
      newErrors.company = "Company is required";
    }

    if (!formData.vehicle_type) {
      newErrors.vehicle_type = "Wheeler Type is required";
    }

    // Validate OEM details
    formData.oemDetails.forEach((oem, index) => {
      if (!oem.name.trim()) {
        newErrors[`oem_${index}_name`] = "OEM Name is required";
      }

      if (!oem.contact.trim()) {
        newErrors[`oem_${index}_contact`] = "OEM Contact is required";
      }

      if (!oem.email.trim()) {
        newErrors[`oem_${index}_email`] = "OEM Email is required";
      } else if (!/^\S+@\S+\.\S+$/.test(oem.email)) {
        newErrors[`oem_${index}_email`] = "Enter a valid email";
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");
        return;
      }

      const formDataToSubmit = {
        vehiclename: formData.vehiclename,
        company: formData.company,
        vehicle_type: formData.vehicle_type,
        vehicleCategory: formData.vehicleCategory,

        feet: formData.feet ? Number(formData.feet) : undefined,
        battery: formData.battery ? Number(formData.battery) : undefined,
        amount: formData.amount ? Number(formData.amount) : undefined,
        firstServiceKm: formData.firstServiceKm
          ? Number(formData.firstServiceKm)
          : undefined,
        firstServiceDays: formData.firstServiceDays
          ? Number(formData.firstServiceDays)
          : undefined,

        secondServiceKm: formData.secondServiceKm
          ? Number(formData.secondServiceKm)
          : undefined,
        secondServiceDays: formData.secondServiceDays
          ? Number(formData.secondServiceDays)
          : undefined,

        thirdServiceKm: formData.thirdServiceKm
          ? Number(formData.thirdServiceKm)
          : undefined,
        thirdServiceDays: formData.thirdServiceDays
          ? Number(formData.thirdServiceDays)
          : undefined,

        fixedServiceKm: formData.fixedServiceKm
          ? Number(formData.fixedServiceKm)
          : undefined,
        fixedServiceDays: formData.fixedServiceDays
          ? Number(formData.fixedServiceDays)
          : undefined,

        // OEM details
        oemDetails: formData.oemDetails.map((oem) => ({
          name: oem.name,
          contact: oem.contact,
          email: oem.email,
        })),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-type/new`,
        formDataToSubmit,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 201) {
        navigate("/type");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);

      if (error.response) {
        console.error("Server Error:", error.response.data);
      }
    }
  };

  return (
    <>
      <Layouts />

      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />

        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          {/* Header */}
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div>{title}</div>

            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>

          <div className="card-body">
            {/* VEHICLE DETAILS */}
            <div className="row justify-content-center">
              {/* Company */}
              <div className="col-md-6 mt-3">
                <label htmlFor="company">
                  <b>Company *</b>
                </label>

                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  className="form-control"
                  onChange={onChangeHandler}
                  value={formData.company}
                />

                {errors.company && (
                  <small className="text-danger">{errors.company}</small>
                )}
              </div>

              {/* Vehicle Type */}
              {/* Vehicle Type */}
              <div className="col-md-6 mt-3">
                <label htmlFor="vehiclename">
                  <b>Vehicle Type *</b>
                </label>

                <select
                  name="vehiclename"
                  className="form-control"
                  value={formData.vehiclename}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Vehicle Type</option>
                  <option value="Closed">Closed</option>
                  <option value="Open">Open</option>
                </select>

                {errors.vehiclename && (
                  <small className="text-danger">{errors.vehiclename}</small>
                )}
              </div>

              {/* Wheeler Type */}
              <div className="col-md-6 mt-3">
                <label htmlFor="vehicle_type">
                  <b>Wheeler Type *</b>
                </label>

                <select
                  name="vehicle_type"
                  className="form-control"
                  value={formData.vehicle_type}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Vehicle Type</option>
                  <option value="2W">2W</option>
                  <option value="3W">3W</option>
                  <option value="4W">4W</option>
                </select>

                {errors.vehicle_type && (
                  <small className="text-danger">{errors.vehicle_type}</small>
                )}
              </div>

              {/* Category */}
              <div className="col-md-6 mt-3">
                <label htmlFor="vehicleCategory">
                  <b>Category</b>
                </label>

                <select
                  name="vehicleCategory"
                  className="form-control"
                  value={formData.vehicleCategory}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Vehicle Category</option>
                  <option value="Ev">EV</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Cng">CNG</option>
                  <option value="Petrol">Petrol</option>
                </select>
              </div>

              {/* Service Interval KM */}
              <div className="col-md-6 mt-3">
                <label htmlFor="firstServiceKm">
                  <b>First Service Interval Km</b>
                </label>

                <input
                  type="number"
                  name="firstServiceKm"
                  placeholder="First Service Interval Km"
                  className="form-control"
                  value={formData.firstServiceKm}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Service Interval Days */}
              <div className="col-md-6 mt-3">
                <label htmlFor="firstServiceDays">
                  <b>First Service Interval Days</b>
                </label>

                <input
                  type="number"
                  name="firstServiceDays"
                  placeholder="First Service Interval Days"
                  className="form-control"
                  value={formData.firstServiceDays}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Service Interval KM */}
              <div className="col-md-6 mt-3">
                <label htmlFor="secondServiceKm">
                  <b>Second Service Interval Km</b>
                </label>

                <input
                  type="number"
                  name="secondServiceKm"
                  placeholder="Second Service Interval Km"
                  className="form-control"
                  value={formData.secondServiceKm}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Service Interval Days */}
              <div className="col-md-6 mt-3">
                <label htmlFor="secondServiceDays">
                  <b>Second Service Interval Days</b>
                </label>

                <input
                  type="number"
                  name="secondServiceDays"
                  placeholder="Second Service Interval Days"
                  className="form-control"
                  value={formData.secondServiceDays}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="thirdServiceKm">
                  <b>Third Service Interval Km</b>
                </label>

                <input
                  type="number"
                  name="thirdServiceKm"
                  placeholder="Third Service Interval Km"
                  className="form-control"
                  value={formData.thirdServiceKm}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Service Interval Days */}
              <div className="col-md-6 mt-3">
                <label htmlFor="thirdServiceDays">
                  <b>Third Service Interval Days</b>
                </label>

                <input
                  type="number"
                  name="thirdServiceDays"
                  placeholder="Third Service Interval Days"
                  className="form-control"
                  value={formData.thirdServiceDays}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="fixedServiceKm">
                  <b>Fixed Service Interval Km</b>
                </label>

                <input
                  type="number"
                  name="fixedServiceKm"
                  placeholder="Fixed Service Interval Km"
                  className="form-control"
                  value={formData.fixedServiceKm}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Service Interval Days */}
              <div className="col-md-6 mt-3">
                <label htmlFor="fixedServiceDays">
                  <b>Fixed Service Interval Days</b>
                </label>

                <input
                  type="number"
                  name="fixedServiceDays"
                  placeholder="Fixed Service Interval Days"
                  className="form-control"
                  value={formData.fixedServiceDays}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Vehicle Feet */}
              {/* Vehicle Feet */}
              <div className="col-md-6 mt-3">
                <label htmlFor="feet">
                  <b>Vehicle Feet</b>
                </label>

                <select
                  name="feet"
                  className="form-control"
                  value={formData.feet}
                  onChange={onChangeHandler}
                >
                  <option value="">Select Vehicle Feet</option>
                  <option value="7">7 ft</option>
                  <option value="8">8 ft</option>
                  <option value="10">10 ft</option>
                  <option value="12">12 ft</option>
                  <option value="14">14 ft</option>
                  <option value="16">16 ft</option>
                </select>
              </div>

              {/* Battery */}
              <div className="col-md-6 mt-3">
                <label htmlFor="battery">
                  <b>Vehicle Battery (KWH)</b>
                </label>

                <input
                  type="number"
                  name="battery"
                  placeholder="Vehicle Battery"
                  className="form-control"
                  value={formData.battery}
                  onChange={onChangeHandler}
                />
              </div>

              {/* Amount */}
              <div className="col-md-6 mt-3">
                <label htmlFor="amount">
                  <b>Amount (Per Unit)</b>
                </label>

                <input
                  type="number"
                  name="amount"
                  placeholder="Per Unit Approx Amount"
                  className="form-control"
                  value={formData.amount}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3"></div>
            </div>

            {/* OEM DETAILS */}
            <div className="mt-4">
              <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                <h5 className="mb-0">OEM Details</h5>

                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={addOEM}
                >
                  + Add OEM
                </button>
              </div>

              {formData.oemDetails.map((oem, index) => (
                <div className="row mt-3 p-3 border rounded" key={index}>
                  <div className="col-md-4">
                    <label>
                      <b>OEM Name *</b>
                    </label>

                    <input
                      type="text"
                      name="name"
                      placeholder="OEM Name"
                      className="form-control"
                      value={oem.name}
                      onChange={(event) => onOEMChangeHandler(index, event)}
                    />

                    {errors[`oem_${index}_name`] && (
                      <small className="text-danger">
                        {errors[`oem_${index}_name`]}
                      </small>
                    )}
                  </div>

                  <div className="col-md-4">
                    <label>
                      <b>OEM Contact *</b>
                    </label>

                    <input
                      type="text"
                      name="contact"
                      placeholder="OEM Contact Number"
                      className="form-control"
                      value={oem.contact}
                      onChange={(event) => onOEMChangeHandler(index, event)}
                    />

                    {errors[`oem_${index}_contact`] && (
                      <small className="text-danger">
                        {errors[`oem_${index}_contact`]}
                      </small>
                    )}
                  </div>

                  <div className="col-md-3">
                    <label>
                      <b>OEM Email *</b>
                    </label>

                    <input
                      type="email"
                      name="email"
                      placeholder="OEM Email"
                      className="form-control"
                      value={oem.email}
                      onChange={(event) => onOEMChangeHandler(index, event)}
                    />

                    {errors[`oem_${index}_email`] && (
                      <small className="text-danger">
                        {errors[`oem_${index}_email`]}
                      </small>
                    )}
                  </div>

                  <div className="col-md-1 d-flex align-items-end">
                    {formData.oemDetails.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removeOEM(index)}
                      >
                        ×
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Submit */}
            <button type="submit" className="btn btn-primary btn-sm mt-4">
              Add Type
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
